import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PrimengModule } from '../../../air/modules/primeng/primeng.module';

import {
    AppBreadcrumbComponent,
    AppConfigComponent,
    ContentHeaderComponent,
    AppMenuComponent,
    AppRightPanelComponent,
    AppMenuitemComponent,
    FilterPanelComponent,
    // GraphComponent,
    // KpiIndicatorComponent,
    PingToWidget,
    CommonTableComponent,
    AppTopBarComponent,
    AppMainComponent,
    AppFooterComponent,
} from './component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppBreadcrumbService, MenuService, AuthService } from './service';
import { MessageService } from 'primeng/api';
import {
    ApiErrorInterceptor,
    ApiRequestInterceptor,
    ApiResponseInterceptor,
    ApiEmptyResponseInterceptor,
} from './interceptor';
import { SafePipe } from './pipe/safepipe';
import { DateTimeFilterComponent } from './component/date-time-filter/date-time-filter.component';
import { AvatarModule } from 'ngx-avatars';
// import { CommonDialogComponent } from './component/common-dialog/common-dialog.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { TrackinglistComponent } from '../user/trackinglist/component/trackinglist/trackinglist.component';
import { AirCommonDialogComponent } from '../../../air/modules/common/component/common-dialog/air-common-dialog.component';
@NgModule({
    declarations: [
        AppBreadcrumbComponent,
        AppConfigComponent,
        ContentHeaderComponent,
        AppMenuComponent,
        AppRightPanelComponent,
        AppMenuitemComponent,
        FilterPanelComponent,
        SafePipe,
        // GraphComponent,
        AppMainComponent,
        DateTimeFilterComponent,
        AirCommonDialogComponent,
        PingToWidget,
        AppTopBarComponent,
        AppMenuComponent,
        CommonTableComponent,
        AppFooterComponent,
    ],
    imports: [
        PrimengModule,
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        AvatarModule,
        NgxDaterangepickerMd.forRoot(),
    ],
    providers: [
        MessageService,
        AppBreadcrumbService,
        MenuService,
        AuthService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiRequestInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiResponseInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiErrorInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiEmptyResponseInterceptor,
            multi: true,
        },
    ],
    exports: [
        PrimengModule,
        FilterPanelComponent,
        ContentHeaderComponent,
        // GraphComponent,
        AirCommonDialogComponent,
        PingToWidget,
        //KpiIndicatorComponent,
        CommonTableComponent,
        AppMainComponent,
        AppTopBarComponent,
        AppMenuComponent,
        AppFooterComponent
        
    ],
})
export class AppCommonModule { }
